/**
 * Track an event with Google Tag Manager
 * @param eventName Name of the event
 * @param eventParams Additional parameters for the event
 */
export function trackEvent(eventName: string, eventParams: Record<string, any> = {}) {
    try {
        // Log to console in development
        if (import.meta.env.DEV) {
            console.group(`[Analytics] Track Event: ${eventName}`);
            console.log('Params:', eventParams);
            console.groupEnd();
        }

        if (typeof window !== 'undefined' && (window as any).gtag) {
            (window as any).gtag('event', eventName, eventParams);
        } else if (import.meta.env.DEV) {
            console.warn('[Analytics] gtag not found');
        }
    } catch (error) {
        if (import.meta.env.DEV) console.warn('[Analytics] Failed to track event:', error);
    }
}
